export default {"src":"/login-app/[GIT_HASH]/_next/static/media/reload.ac5f7aa4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};